import React from 'react';
import { Form } from 'react-bootstrap';
import { getColor } from '@/helpers/utils';
import type { TermsCheckboxProps } from '../../types/purchaseTypes';

function TermsCheckbox({
  agreedWithTerms,
  setAgreedWithTerms,
  isError,
  setIsError,
}: TermsCheckboxProps) {
  const handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    if (isError && target.checked) {
      setIsError(false);
    }
    setAgreedWithTerms(target.checked);
  };

  return (
    <Form.Group className="container mt-2 w-lg-50">
      <Form.Check
        isInvalid={isError}
        type="checkbox"
        id="agreedToTerms"
        className="mb-0"
      >
        <Form.Check.Input
          isInvalid={isError}
          type="checkbox"
          name="agreedToTerms"
          onChange={handleChange}
          checked={agreedWithTerms}
        />
        <Form.Check.Label className="mb-0 cursor-pointer ms-1">
          صفحه{' '}
          <a
            href="https://mizfa.tools/terms-of-service/"
            target="_blank"
            rel="noreferrer noopener"
            style={{
              color: getColor('navbar-vertical-default-link-active-color')
            }}
          >
            شرایط استفاده از خدمات
          </a>{' '}
          را خواندم و موافقم.
        </Form.Check.Label>
        <Form.Control.Feedback type="invalid" className="mt-0">
          شرایط استفاده از خدمات رو مطالعه نکردید!
        </Form.Control.Feedback>
      </Form.Check>
    </Form.Group>
  );
};

export default TermsCheckbox;

